<header>
    <div class="container">
        <nav class="navbar navbar-expand-lg ">
            <div class="container-fluid">
              <a class="navbar-brand">
                <img src="	https://modern.b-cdn.net/wp-content/uploads/2021/09/white-logo.png" alt="">
              </a>
              <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="collapse navbar-collapse" id="navbarText">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                  <li class="nav-item">
                    <a class="nav-link active" aria-current="page">Home</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link">Features</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link">Pricing</a>
                  </li>
                </ul>
                <span class="navbar-text">
                 <ul>
                    <li>Login</li>
                    <li>Register</li>
                    <li><button class="btn" type="button">Sell your car</button></li>
                 </ul>
                </span>
              </div>
            </div>
          </nav>
    </div>
</header>
  <section>
    <div class="bannerSec">
      <figure  class="m-0">
        <mdb-carousel class="carousel slide carousel-fade">
          <mdb-carousel-item *ngFor="let item of media">
            <img *ngIf="item.MediaType == 'I' && item.MediaURL" [src]="item.MediaURL"
              class="d-block w-100" alt="image" (error)="item.MediaURL = null" style="height: 700px !important" />
            <video *ngIf="item.MediaType != 'I' && item.MediaURL" class="d-block w-100" controls
              (error)="item.MediaURL = null"  style="height: 700px !important">
              >
              <source [src]="item.MediaURL" type="video/mp4" (error)="item.MediaURL = null" />
              Your browser does not support the video tag.
            </video>
            <h4 *ngIf="!item.MediaURL">
              <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/not-found.png" />
            </h4>
          </mdb-carousel-item>
        </mdb-carousel>
      </figure >
      <div class="letusContact" style="z-index: 10 !important">
        <span class="phoneIcon">
          <i class="fa-solid fa-phone-volume"></i>
        </span>
        <form class="propertyForm">
          
          <h3>Let Us Call You!</h3>
          <p>To help you choose your property</p>
          <div class="mb-3">
            <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Your Name">
          </div>
          <div class="mb-3">
            <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Your Number">
          </div>
          <div class="mb-3">
            <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Your Email">
          </div>
         
          <div class="mb-3 ">
            <textarea name="message" class="textFiled" placeholder="Tell us about desired property"></textarea>
          </div>
          <div class="mb-3 form-check">
            <input type="checkbox" class="form-check-input" id="exampleCheck1">
            <label class="form-check-label" for="exampleCheck1">I consent to having this website store my submitted information so they can respond to my inquiry.</label>
          </div>
          
            <button type="submit" class="btn btn-primary">Submit</button>
        </form>
      </div>
    </div>
  </section>


    <section class="recentProperties py-5">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12 text-center">
            <div class="recentContent">
              <span>Recent</span>
              <h2>Properties</h2>
              <p>Check out some of our latest properties.</p>
            </div>
          </div>
          <ng-container *ngFor="let list of dealerListingData">
          <div class="col-md-4 col-sm-4"  *ngIf="list.IsFeatured == 'N'">
            <div class="listingCard propertyCard" (click)="navigate(list.ListingHandle)">
              <div class="imageWrapper">
                <mdb-carousel class="carousel slide carousel-fade">
                    <mdb-carousel-item *ngFor="let item of getImages(list)">
                      <img *ngIf="item.MediaType == 'I' && item.MediaURL" [src]="item.MediaURL"
                        class="d-block w-100 rounded" alt="image" (error)="item.MediaURL = null" />
                      <video *ngIf="item.MediaType != 'I' && item.MediaURL" class="d-block w-100 rounded" controls
                        (error)="item.MediaURL = null">
                        >
                        <source [src]="item.MediaURL" type="video/mp4" (error)="item.MediaURL = null" />
                        Your browser does not support the video tag.
                      </video>
                      <h4 *ngIf="!item.MediaURL">
                        <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/not-found.png" />
                      </h4>
                    </mdb-carousel-item>
                  </mdb-carousel>
                  <!-- <a href="#"><img src="https://modern.b-cdn.net/wp-content/uploads/2017/06/exterior-05-488x326.jpg" alt=""></a> -->
                  <div class="tagsBox d-flex justify-content-between align-items-center p-3">
                    <div class="d-flex">
                      <a href="#"><img src="https://modern.b-cdn.net/wp-content/uploads/2015/07/agent-female-00-210x210.jpg" alt=""></a>
                      <div class="agentAgency ms-2">
                        <p class="m-0"><a href="#">Melissa William</a></p>
                        <p class="m-0"><a href="#">James Estate Agents</a></p>
                      </div>
                    </div>
                    <div class="propStatus">
                      <span>For Sale</span>
                    </div>
                  </div>
              </div>
              <div class="bottomDetails border-0">
                  <div class="paddingSection">
                      <a (click)="navigate(list.ListingHandle)" class="headingBlackColor">
                          <h5>Home in {{list.ListingHeader}}</h5>
                      </a>

                      <div class="location">
                       <a (click)="navigate(list.ListingHandle)" class="address">
                        <i class="fa-solid fa-location-dot"></i>
                        {{list.Location}}
                       </a>
                      </div>

                      <div class="addedSty">
                          <span>Added:</span> {{list.PossessionDate | date }}
                      </div>

                      <ul>
                          <li>
                              Bedrooms
                              <div class="metaIcon mt-1">
                                <i class="fa-solid fa-bed"></i>
                                <span>{{list.Rooms}}</span>
                              </div>
                          </li>

                          <li>
                              Bathrooms
                              <div class="metaIcon mt-1">
                                <i class="fa-solid fa-shower"></i>
                                <span>{{list.Bathrooms}}</span>
                              </div>
                          </li>
                          <li>
                              Area
                              <div class="metaIcon mt-1">
                                <i class="fa-sharp fa-regular fa-square"></i>
                                <span>{{list.Area}}</span>
                                <span>Sq Ft</span>
                              </div>
                          </li>
                      </ul>
                      <div class="price-fav-box">
                        <div class="price-pabel">
                            <span class="card-status"> For Sale    </span>
                            <p class="card-price"> {{dealerData?.PrimaryCurrencyText}} {{list.AskingPrice}}    </p>
                        </div>
    
    
                        <div class="icon-box">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 21">
                                    <path class="rh_svg" d="M1089.48,1923.98a6.746,6.746,0,0,1,9.54,9.54L1089,1943l-10.02-9.48a6.746,6.746,0,0,1,9.54-9.54A0.641,0.641,0,0,0,1089.48,1923.98Z" transform="translate(-1077 -1922)"></path>
                                </svg>							
                                <a href="#" class="favorite add-to-favorite user_not_logged_in" data-propertyid="45" data-tooltip="Add To Favourite">
                                    <a class="rh_trigger_compare rhea_add_to_compare" data-tooltip="Add To Compare" href="https://modern.realhomes.io/property/home-in-merrick-way/">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                          <path d="M1144,1942l-8,1v3l-7-5,7-5v3l8,1A1,1,0,0,1,1144,1942Zm-22-14,8,1v3l7-5-7-5v3l-8,1A1,1,0,0,0,1122,1928Z" transform="translate(-1121 -1922)"></path>
                        </svg>
                                    </a>					
                                </a>
                         
                        </div>
                      </div>
                  </div>
                 
              </div>
             
            </div>
          </div>
          </ng-container>
        </div>
      </div>
    </section>
   
    <section class="featuredProperties py-5">
      <div class="container">
          <div class="row">
              <div class="col-md-12">
                  <div class="recentContent text-center">
                      <span>Check out</span>
                      <h2>Featured Properties</h2>
                      <p>View list of our short listed properties</p>
                  </div>
              </div>
              <owl-carousel [options]="carouselOptions" [items]="dealerListingData" [carouselClasses]="['owl-theme', 'row', 'sliding']">
                <ng-container *ngFor="let list of dealerListingData;let i= index">
                <div class="item" *ngIf="list.IsFeatured == 'Y'" >
                  <div class="card" (click)="navigate(list.ListingHandle)">
                  <img class="slide-image" src="https://modern.b-cdn.net/wp-content/uploads/2020/06/exterior-00-818x417.jpg"> 
                   <div class="slide-text">
                    <div class="cardDetail">
                      <span class="labelFeatured">Featured</span>
                      <h3><a (click)="navigate(list.ListingHandle)" class="headingBlackColor">Home in {{list.ListingHeader}}</a></h3>
                      <p>{{list.Description}}</p>
                      <ul class="d-flex mb-3">
                        <li>
                            Bedrooms
                            <div class="metaIcon mt-1">
                              <i class="fa-solid fa-bed"></i>
                              <span>{{list.Rooms}}</span>
                            </div>
                        </li>

                        <li class="mx-4">
                            Bathrooms
                            <div class="metaIcon mt-1">
                              <i class="fa-solid fa-shower"></i>
                              <span>{{list.Bathrooms}}</span>
                            </div>
                        </li>
                        <li>
                            Area
                            <div class="metaIcon mt-1">
                              <i class="fa-sharp fa-regular fa-square"></i>
                              <span>{{list.Area}}</span>
                              <span>Sq Ft</span>
                            </div>
                        </li>
                    </ul>
                    <div class="price-fav-box">
                      <div class="price-pabel">
                          <span class="card-status">For Sale</span>
                          <p class="card-price">{{dealerData?.PrimaryCurrencyText}} {{list.AskingPrice}} </p>
                      </div>
                      <div class="icon-box">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 21">
                        <path class="rh_svg" d="M1089.48,1923.98a6.746,6.746,0,0,1,9.54,9.54L1089,1943l-10.02-9.48a6.746,6.746,0,0,1,9.54-9.54A0.641,0.641,0,0,0,1089.48,1923.98Z" transform="translate(-1077 -1922)"></path>
                        </svg>    
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path d="M1144,1942l-8,1v3l-7-5,7-5v3l8,1A1,1,0,0,1,1144,1942Zm-22-14,8,1v3l7-5-7-5v3l-8,1A1,1,0,0,0,1122,1928Z" transform="translate(-1121 -1922)"></path>
                        </svg>  
                      </div>
                    </div>
                  </div>
                  </div>
                  </div>
                </div>
                </ng-container>
              </owl-carousel>

             
          </div>
      </div>
  </section>
  